import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

const SLOT_COUNT = 5;

@Component({
	selector: 'xp-rating-stars',
	standalone: true,
	imports: [CommonModule, MatIconModule],
	templateUrl: './xp-rating-stars.component.html',
	styleUrls: ['./xp-rating-stars.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpRatingStarsComponent {
	rating = input(0);
	icon = input<string | null>(null);
	filledSrc = input<string | null>(null);
	emptySrc = input<string | null>(null);

	slots = computed<boolean[]>(() => {
		const filled = Math.max(0, Math.min(SLOT_COUNT, Math.round(Number(this.rating()) || 0)));
		return Array.from({ length: SLOT_COUNT }, (unused, index) => index < filled);
	});
}
